/* 
 * Vue components for this site
 */

window.Vue.component('client-note',{
  name: 'client-note',
  mixins: [window.ajaxpostingMixin, window.formatMixin],
  template: `
  <div class='popup-container input-container' :class="params.wrapcss" :style="params.wrapstyle">
  <input type='hidden' v-model="params.client_id" name="client_id">
  <div class="client-note-header border" :style="header">In the event of conflict/liability, your own notes are not significant in court because you can modify the entry & date. The notes you enter here are confidential, but since they can't be changed, they can substantiate your history</div>

<div class='h-flex fullwidth'>
  <pk-select-arr style="flex-grow:1; flex-basis: 50%;" :inpopt="params.selectparams"></pk-select-arr>
  <pk-input-arr style="flex-grow:1; flex-basis: 50%;" :inpopt="params.summaryparams"></pk-input-arr>
</div>
  <pk-textarea-arr style="width: 100%; flex-grow:1;" :inpopt="params.textparams"></pk-textarea-arr>
  </div>
`,
  data: function() {
    return {
      date: moment(new Date()).format('ll'),  
      refs:[],
      header: 'font-size: small; color: #400; font-style:italic;margin: 3px;',
      parent:{},
      root:{},

    };
  },
  mounted: function() {
    
    console.log("In Client Note: The incoming params:", this.params);
    this.refs=this.params.refreshname;
    this.parent = this.$parent;
    this.root = this.$root;

    console.log("This refs:",this.refs,"This Parent:",this.parent,"Root,",this.root);
    //this.client_id = this.params.client_id
  },
  //myDate =  moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  props: ['params'],
  methods: {
    submit: function(event) {
      console.log("Modal fowraded to us - simpler");
      var proxy={
        date:moment(new Date()).format("YYYY-MM-DD"),
      };
      var fields = this.fetchDataNoFD(proxy);
      var subd = {model: "\\App\\Models\\ClientLog",
                   fields: fields};
      //This is what we submit to AJAX - check the form...
      console.log("The filsa qw qill send: ; subd:",subd); 
      /*
      var subd = new FormData();
       subd.append ('fields',this.fetchData(proxy));
       subd.append ('model', "\\App\\Models\\ClientLog");
      var subdata = {
        fields: this.fetchData(proxy),
        model: "\\App\\Models\\ClientLog",
      };
      */
      this.autoSubmit('/ajax/submit',subd);
    }
  }
});
  


window.Vue.component('client-notes',{
  name: 'client-notes',
  mixins: [window.ajaxpostingMixin, window.formatMixin],
  template: `<div class="notes-wrapper" :class="noteswrapper" :style="notwrpstyle">
  <div :style="notesectionhead">Notes from interactions with {{params.full_name}}</div>

  <div :style="noteitemstyle" class="note" :class="note_loop" v-for="(note, idx) in notes">
    <div :style="noteheader" class="note-header">
         {{note.date_DV}} --  {{note.interaction_id_DV}}</div>
    <div :style="note_sum" class="note-summary">{{note.summary}}</div>
    <div :style="notebody" class="note-body">{{note.notes}}</div>
  </div>
</div>`,
  data: function() {
    return {
      notes:[],
      notwrpstyle:"width: 300px;border: solid #444 1px;\n\
                    display: flex; flex-direction:column",
      notesectionhead:`width:100%; padding 1em; text-align:center;
                     font-size: large; color:white; background: #33b;
                     margin-bottom: 3px; border-bottom: solid black 3px;`,
      noteheader:`border: solid #aaf 1px; padding: .5em; color:black;
                  background: #ccf;`,
      note_sum:'color: #aaf; background: #989;',
      notebody:'border: solid blue 1px; padding: 1em; text-align: left;',
      noteitemstyle:'',
      note_loop:'',
      noteswrapper:'',
    };
  },
  props: ['params'],//just client_id & full_name
  mounted: function() {
    this.initData();
  },
  methods: {
    initData() {
      console.log("Running initData for Notes");
      axios.post("/ajax/fetchattributes",
      {model: "\\App\\Models\\ClientLog",
        orderby: {date:"desc"},
        searchkeys: {client_id:this.params.client_id},
        keys:['interaction_id_DV','notes','summary','date_DV'],
      }).then(response=>{
        console.log("The succes data:", response.data);
        this.notes=response.data;
      }).catch(error=>{console.error("Problem fetching notes:",error,error.response);});
    },
  }
});

/* 
 * Mental Health Vue components, to be built with ES6 support
 */
/** Send message - from SBC - modify - content of popup.
 * prop params: has to have user_id_to
 * @type type
 */
window.Vue.component('msg-subform',{
  name:'msg-subform',
  mixins: [window.ajaxpostingMixin],
  template:`
  <div>
      <p>We won't send any of your contact details - they will get
        an email from us with a link to view your message on this site</p>
        <input type='hidden' name='user_id_to' v-model='params.user_id_to' />
        <textarea v-model="params.message" name='message'
          class='fullwidth fullheight block jq-wipe'></textarea>
  </div>
    `,
   props: ['params'], //Has to have the ID person messaged
   data: function() {
     return {
       ajaxurl: '/ajax/sendmessage',
     };
   },
   mounted: function() {
     console.log("msg_subform - params:", this.params);
   },
   methods: {
     submit: function() {
       console.log("Our params reloadrefs:",this.params.reloadrefs);
       this.autoSubmit(this.ajaxurl);
     }
   }
   
  //Has message, user_id_to, btnlbl, title,url, optionally, css classes & config
});

/** It will repeat several panes, maybe on separate pages */
window.Vue.component('msg-component',{
  name:'msg-component',
  template: `
  <div class='msg-cell-wrap'>
    <div class="msg top-row head" :class="headcls">
      <div class="msg-to" :class="msgto item" v-html="msg.tofullname"></div>
      <div class="item date"" :class="dt" v-html="formatDate(msg.date)"></div>
      <div class="msg-from" v-html="msg.fromfullname"></div>
  </div>
  <div class='subect-row mrow' :class="cs-subjet-row" v-html="msg.subject"></div>
  <div class='body-row mrow' :class="cs-body-row" v-html="msg.message"></div>
</div>
`,

data: function() {
  return {
    msg:{}
    };
  },
  props:['params',],
  mounted: function() {
  },
  methods: {
  },
});

/** It will repeat several panes, maybe on separate pages */
window.Vue.component('msg-panel',{
props:['params',],
template: `
  <div class="msgs-colum">
  <msg-component v-for("(msg,idx ) in msgs"   :params="params"></msg-component>
  <div <div class="bottom-btn-row tac">
      <pk-modal-wrapper :params="params"></pk-modal-wrapper>
    </div>
  </div>
`,
  props: ['params'],
  mounted: function() {
  },
});





















